// // tokenManager.js
// import jwt_decode from 'jwt-decode';
// import axios from 'axios';

// let refreshTimer;

// const API_URL = process.env.REACT_APP_API_URL;

// export const startSilentRefresh = () => {
//   const access = localStorage.getItem('access_token');
//   const refresh = localStorage.getItem('refresh_token');
//   if (!access || !refresh) return;

//   const { exp } = jwt_decode(access);
//   const now = Math.floor(Date.now() / 1000);
//   const expiresIn = exp - now;

//   const refreshIn = Math.max(expiresIn - 60, 0) * 1000;

//   if (refreshTimer) clearTimeout(refreshTimer);

//   refreshTimer = setTimeout(async () => {
//     try {
//       const res = await axios.post(`${API_URL}/api/token/refresh/`, {
//         refresh,
//       });
//       const newAccess = res.data.access;
//       localStorage.setItem('access_token', newAccess);
//       axios.defaults.headers.common['Authorization'] = `Bearer ${newAccess}`;
//       startSilentRefresh(); // restart loop
//     } catch (e) {
//       console.error('Token refresh failed', e);
//       logout();
//     }
//   }, refreshIn);
// };

// export const logout = async () => {
//   const refresh = localStorage.getItem('refresh_token');
//   try {
//     await axios.post(`${API_URL}/api/logout/`, { refresh });
//   } catch {}

//   localStorage.clear();
//   window.location.href = '/login';
// };


import { jwtDecode } from 'jwt-decode';
import { api } from './axiosConfig';
import axios from 'axios';

let refreshTimer = null;
const API_URL = process.env.REACT_APP_API_URL;

export const startSilentRefresh = () => {
  const access = localStorage.getItem('access_token');
  const refresh = localStorage.getItem('refresh_token');

  if (!access || !refresh) return;

  let decoded;
  try {
    decoded = jwtDecode(access);
  } catch {
    return; // malformed token
  }

  const now = Math.floor(Date.now() / 1000);
  const expiresIn = decoded.exp - now;

  // If already expired, refresh immediately; otherwise schedule 60s before expiry
  const refreshIn = Math.max((expiresIn - 60) * 1000, 0);

  if (refreshTimer) clearTimeout(refreshTimer);

  refreshTimer = setTimeout(async () => {
    try {
      // Use plain axios to avoid triggering the 401 interceptor in a loop
      const res = await axios.post(`${API_URL}/api/token/refresh/`, { refresh });
      const newAccess = res.data.access;

      localStorage.setItem('access_token', newAccess);
      api.defaults.headers.common['Authorization'] = `Bearer ${newAccess}`;

      startSilentRefresh(); // reschedule
    } catch (e) {
      console.error('Silent refresh failed:', e);
      logout();
    }
  }, refreshIn);
};

export const stopSilentRefresh = () => {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
};

export const logout = async () => {
  stopSilentRefresh();
  const refresh = localStorage.getItem('refresh_token');

  try {
    await api.post('/api/logout/', { refresh });
  } catch {
    // best-effort blacklist — don't block logout
  }

  localStorage.clear();
  window.location.href = '/login';
};